// extracted by mini-css-extract-plugin
export default {"iconWrapper":"Icon_iconWrapper_nbqW9","svg":"Icon_svg_c48j3"};